import styled from "styled-components";
import { colors } from "../../styles/variables.js";
export const StyledFooter = styled.footer`
	display: flex;
	justify-content: space-around;
	align-items: center;
	height: 3.2rem;
	margin-top: 1rem;
	border-top: 1px solid ${colors.secondary1};

	p {
		color: ${colors.primary4};
		font-size: 0.8rem;
	}
`;
